import { useState, useEffect } from "react";
import { Container, Row, Col, DropdownButton, Dropdown } from "react-bootstrap";
import WidgetElement from "./WidgetElement";
import { useGetCurrentVendor, useGetVendorId } from "../../hooks/global/User";
import { useTranslation } from "react-i18next";
import { getProductGroups, getProducts } from "../../fetchers/products";
import { useGetAvailableLanguages, useSelectLanguage } from "../../hooks/global/Languages";

function Widgets() {
  const { t, i18n } = useTranslation();
  const vendorId = useGetVendorId();
  const availableLanguages = useGetAvailableLanguages()

  const [lng, setlng] = useState(i18n.language);
  const [group, setGroup] = useState("");
  const [product, setProduct] = useState("");
  const [elements, setElements] = useState([]);
  const [modules, setModules] = useState([]);

  const { selectTextByLanguage } = useSelectLanguage()

  const vendor = useGetCurrentVendor();

  let params = {
    vendorId: vendorId,
    group: group.id,
    product: product.name,
    lang: lng ? lng.toUpperCase() : i18n.language,
  };

  useEffect(() => {
    setlng(availableLanguages.includes(i18n.language)? i18n.language: availableLanguages[0]);
  }, [i18n.language]);

  useEffect(() => {
    getProductGroups(params).then((vendorModules) => {
      setModules(vendorModules);
      setGroup(vendorModules[0]);
      setProduct("");
    });
  }, []);

  useEffect(() => {
    getProducts(params).then((vendorProducts) => {
      setElements(vendorProducts);
    });
  }, [group]);


  const handleProductClick = (element) => {
    setProduct(element);
  };

  const handleModuleClick = (modul) => {
    setGroup(modul);
    setProduct("");
  };

  return (
    <div id="artur-widgetOverview">
      <Container>
        <Row>
          {lng.length > 0 && (
            <Col md={12} className="content">
              <h2>
                {t("admin.wid.h1")}
                <span className="code"></span>
              </h2>
              <p>{t("admin.wid.h2")}</p>
              <Row className="widgetFilterWrap">
                <Col md={4}>
                  <div className="dropdownWrap dropdownWrap-wide clearfix">
                    <DropdownButton
                      title={group ? selectTextByLanguage(group.nametoshow, lng) : selectTextByLanguage(modules[0]?.nametoshow, lng)}
                      id="selectModule"
                    >
                      {modules.map((modul, index) => {
                        return (
                          <Dropdown.Item
                            key={index}
                            eventKey={index + 2}
                            role="menuitem"
                            onClick={(e) =>  handleModuleClick(modul) }
                          >
                            {selectTextByLanguage(modul.nametoshow, lng)}
                          </Dropdown.Item>
                        );
                      })}
                    </DropdownButton>
                  </div>
                </Col>
                <Col md={4}>
                  {" "}
                  <div className="dropdownWrap dropdownWrap-wide clearfix">
                    <DropdownButton
                      id="selectModuleItem"
                      title={ product ? selectTextByLanguage(product.nametoshow, lng): t("admin.common.allElements")}
                    >
                      <Dropdown.Item
                        eventKey="1"
                        role="menuitem"
                        onClick={(e) => setProduct("")}
                      >
                        {t("admin.common.allElements")}
                      </Dropdown.Item>
                      {elements.map((element, index) => {
                        return (
                          <Dropdown.Item
                            key={index}
                            eventKey={index + 2}
                            role="menuitem"
                            onClick={(e) => handleProductClick(element)}
                          >
                            {selectTextByLanguage(element.nametoshow, lng)}
                          </Dropdown.Item>
                        );
                      })}
                    </DropdownButton>
                  </div>
                </Col>
                <Col md={4}>
                  {" "}
                  {vendor && (
                    <div className="dropdownWrap dropdownWrap-wide clearfix">
                      <DropdownButton
                        id="selectModuleItem"
                        title={lng ? lng : t("admin.wid.selectLng")}
                      >
                        {vendor.languages.map((lang, index) => {
                          return (
                            <Dropdown.Item
                              key={index}
                              eventKey={index + 2}
                              role="menuitem"
                              onClick={(e) => setlng(lang)}
                            >
                              {lang}
                            </Dropdown.Item>
                          );
                        })}
                      </DropdownButton>
                    </div>
                  )}
                </Col>
              </Row>
              <Row className="rowWidget rowWidget-first">
                <Col
                  md={{ span: 5, offset: 1 }}
                  sm={6}
                  className="widgetPortraitLargeWrap"
                >
                  <h4>{t("admin.wid.h3")}</h4>
                  <h5>150px * 180px</h5>
                  <WidgetElement
                    vendorId={vendorId}
                    lng={lng}
                    width={"150"}
                    height={"180"}
                    type={"reviews"}
                    orientation={"portrait"}
                    selectedModuleQueryParam={group}
                    selectedElementQueryParam={product}
                  />
                </Col>
                <Col
                  md={{ span: 5, offset: 1 }}
                  sm={6}
                  className="widgetLandscapeWrap"
                >
                  <h4>{t("admin.wid.h4")}</h4>
                  <h5>160px * 75px</h5>
                  <WidgetElement
                    vendorId={vendorId}
                    lng={lng}
                    width={"160"}
                    height={"75"}
                    type={"recommendations"}
                    orientation={"landscape"}
                    selectedModuleQueryParam={group}
                    selectedElementQueryParam={product}
                  />
                </Col>
                <Col
                  md={{ span: 5, offset: 1 }}
                  sm={6}
                  className="widgetPortraitSmallWrap"
                >
                  <h4>{t("admin.wid.h5")}</h4>
                  <h5>110px * 130px</h5>
                  <WidgetElement
                    vendorId={vendorId}
                    lng={lng}
                    width={"110"}
                    height={"130"}
                    type={"reviews"}
                    orientation={"portrait"}
                    selectedModuleQueryParam={group}
                    selectedElementQueryParam={product}
                  />
                </Col>
                <Col
                  md={{ span: 5, offset: 1 }}
                  sm={6}
                  className="widgetLandscapeWrap"
                >
                  <h4>{t("admin.wid.h6")}</h4>
                  <h5>160px * 75px</h5>
                  <WidgetElement
                    vendorId={vendorId}
                    lng={lng}
                    width={"160"}
                    height={"75"}
                    type={"reviews"}
                    orientation={"landscape"}
                    selectedModuleQueryParam={group}
                    selectedElementQueryParam={product}
                  />
                </Col>
              </Row>
            </Col>
          )}
        </Row>
      </Container>
    </div>
  );
}

export default Widgets;
